import Image from 'next/image'
import { EmptyStateContainer } from './styled'
import { Typography } from '@mui/material'

const EmptyState = () => {
  return (
    <EmptyStateContainer>
      <Image alt="No results image" src="/assets/blog/no_results.webp" width={240} height={240} />
      <Typography variant="h3" sx={{ textAlign: 'center' }}>
        We couldn&apos;t find what you were looking for.
      </Typography>
      <Typography variant="body1" sx={{ textAlign: 'center' }}>
        Try adjusting your filters or entering a different keyword.
      </Typography>
    </EmptyStateContainer>
  )
}

export default EmptyState
